import type Keycloak from 'keycloak-js';

/**
 * Global middleware for protected pages. Runs first (01 prefix).
 * Skipped for /error and /health to avoid redirect loops and blocking health checks.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === '/error' || to.path === '/health' || to.path === '/qrCodeValidation') return;
  if (import.meta.server) return;

  const nuxtApp = useNuxtApp();
  const keycloak = nuxtApp.$keycloak as Keycloak;

  if (keycloak.authenticated) {
    // only return is necessary to continue navigation
    return;
  } else {
    let errorDetail = '';
    try {
      await keycloak.init({
        onLoad: 'login-required',
      });
    } catch (e) {
      errorDetail = JSON.stringify(e);
    }

    if (errorDetail !== '') {
      return navigateTo('/error?errorMessage=KEYCLOAK_ERROR&errorDetail=' + errorDetail, { redirectCode: 301 });
    }
  }
});
